import Textarea from 'react-textarea-autosize'
import { toastr } from 'react-redux-toastr'

import TooltipValidator from './TooltipValidator.jsx'
import './style.scss'

let it = 0

export const merge = {
  TOP: 'top',
  BOTTOM: 'bottom'
}

const Input = (field) => {
  const name = 'i' + (field.input.name || it++)
  const id = (field.id ? field.id : `${field.meta.form}_${name}`).replace(/\./g, '_')
  const type = (field.type || '').toLowerCase()

  const currentValue = field.input?.value || ''
  const valueLength = currentValue.length
  const maxLength = field.maxLength
  const remaining = maxLength ? Math.max(maxLength - valueLength, 0) : null

  const classes = []
  if (typeof field.className === 'string') classes.push(field.className)

  if (field.meta.visited || !field.meta.pristine || field.meta.submitFailed) {
    classes.push(field.meta.valid ? 'is-valid' : 'is-invalid')
  }

  const isCheckbox = type === 'checkbox' || type === 'radio'
  if (!isCheckbox) classes.push('form-control')

  const mergeClasses = ['form-group']
  if (field.merge === merge.TOP) mergeClasses.push('merge-top')
  if (field.merge === merge.BOTTOM) mergeClasses.push('merge-bottom')
  if (typeof field.wrapperClassName === 'string') {
    mergeClasses.push(field.wrapperClassName)
  }

  const className = classes.join(' ')
  const spaceBeforeLabel = field.spaceBeforeLabel !== false

  const showLimitToast = (message) => {
    toastr.error('Limite atteinte', message)
  }

  const handleKeyDown = (e) => {
    if (!maxLength) return

    const isControlKey =
      e.ctrlKey ||
      e.metaKey ||
      ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)

    if (isControlKey) return

    if (currentValue.length >= maxLength) {
      showLimitToast(`Ce champ est limité à ${maxLength} caractère${maxLength > 1 ? 's' : ''}.`)
      e.preventDefault()
    }
  }

  const handlePaste = (e) => {
    if (!maxLength) return

    const pastedText = e.clipboardData.getData('text')
    const selectionStart = e.target.selectionStart
    const selectionEnd = e.target.selectionEnd

    const newLength =
      currentValue.length -
      (selectionEnd - selectionStart) +
      pastedText.length

    if (newLength > maxLength) {
      showLimitToast(
        `Le texte collé a été tronqué car il dépasse la limite de ${maxLength} caractère${maxLength > 1 ? 's' : ''}.`
      )
    }
  }

  const handleChange = (e) => {
    field.input.onChange(e)
    if (field.customOnChange) field.customOnChange(e)
  }

  const handleBlur = (e) => {
    if (field.customOnBlur) field.customOnBlur(e)
  }

  const commonProps = {
    ...field.input,
    type: field.type || 'text',
    id,
    placeholder: field.placeholder,
    maxLength,
    className,
    onChange: handleChange,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    onPaste: handlePaste
  }

  return (
    <div className={mergeClasses.join(' ')}>
      {!isCheckbox && field.label && <label htmlFor={id}>{field.label}</label>}

      {maxLength && (
        <small className="helper">
          {remaining} caractère{remaining > 1 ? 's' : ''} restant{remaining > 1 ? 's' : ''}
        </small>
      )}

      <TooltipValidator
        field={field}
        target={field.errorTarget || id}
        checkActive={!isCheckbox}
      />

      {type === 'textarea' ? (
        <Textarea
          {...commonProps}
          minRows={2}
          maxRows={8}
        />
      ) : (
        <input {...commonProps} />
      )}

      {field.children}

      {isCheckbox && field.label && (
        <label htmlFor={id}>
          {spaceBeforeLabel ? '\u00A0' : ''}
          {field.label}
        </label>
      )}
    </div>
  )
}

export default Input
